export default "__VITE_ASSET__ee831d83__"